import { publish, subscribe } from '../utils/pubsub';

class WssEventNotifier {
    /**
     * Notifies a target component of a named event.
     *
     * @param {string} channel - event channel aka the wss event OnCardDataUpdated
     * @param {any} data - the deserialized data part of this event
     */
    notify = (channel, data = null) => {
        publish(channel, data);
    };

    /**
     * Subscribes to event channel aka OnCardDataUpdated
     *
     * @param {string} channel - engine name e.g. EngineNames.TemplateEngine
     * @param {Function} fn - callback for handling the event data
     *
     * @returns {Function} unsubscribe function
     */
    subscribe = (channel, fn) => {
        return subscribe(channel, (e) => {
            // if (e.name !== name) return;
            fn(e);
        });
    };
}

const wssEventNotifier = new WssEventNotifier();
export default wssEventNotifier;
